import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "createAdminSuccess",
  tabindex: "-1",
  "aria-labelledby": "createAdminSuccess",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header border-bottom-0" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "w-100 text-center mb-4" }
const _hoisted_7 = { class: "d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { getMessage } from '@/constants/messageCode.ts'


export default /*#__PURE__*/_defineComponent({
  props: {
  serverError: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(!__props.serverError ? _unref(translate)('registered') : _unref(getMessage)(__props.serverError)), 1),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              class: "me-2"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})